import React, { Component } from 'react'
import SpecialProjects from './component'
import { connect } from 'react-redux'

import { fetchProjects, submitProject, deleteProject } from '../../../redux/projects'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'

class SpecialProjectsContainer extends Component {
  state = {
    selectedBusiness: null,
    selectedProject: null,
    submittedProject: null
  }

  componentDidMount () {
    this.props.fetchProjects(this.props.teamNumber, this.props.selectedRound)
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.isCurrentTab && !prevProps.isCurrentTab) {
      this.setState({ selectedProject: null, selectedBusiness: null })
      return this.props.fetchProjects(this.props.teamNumber, this.props.selectedRound)
    }
    if (this.props.selectedRound !== prevProps.selectedRound || this.props.roundNumber !== prevProps.roundNumber || this.props.teamNumber !== prevProps.teamNumber) {
      this.setState({ selectedProject: null, selectedBusiness: null })
      return this.props.fetchProjects(this.props.teamNumber, this.props.selectedRound)
    }
    if (!prevState.selectedProject && this.props.projects) {
      this.setState({ selectedProject: this.props.projects[0].id })
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  handleSelectBusiness = (business) => {
    this.setState({ selectedBusiness: parseInt(business) })
  }

  handleSelectProject = (project) => {
    this.setState({ selectedProject: parseInt(project), selectedBusiness: null })
  }

  handleDeselectProject = () => {
    this.props.deleteProject(this.props.teamNumber, this.props.selectedRound)
    this.handleDeselectBusiness()
  }

  handleDeselectBusiness = () => {
    this.setState({ selectedBusiness: null })
  }

  canSubmit = () => {
    const projectToSubmit = this.props.projects.find(p => p.id === this.state.selectedProject)
    return !projectToSubmit.options || this.state.selectedBusiness
  }

  submitProject = () => {
    this.props.submitProject(this.props.teamNumber, this.props.selectedRound, this.state.selectedProject, this.state.selectedBusiness)
  }

  handleSubmit = () => {
    return this.props.projects.find(p => p.usedInRound === this.props.roundNumber)
  }

  render () {
    if (this.props.isLoading) {
      return <CenteredSpinner />
    }
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }
    return (
      <SpecialProjects
        items={this.props.projects}
        onSelectProject={this.handleSelectProject}
        selectedProject={this.state.selectedProject}
        round={this.props.selectedRound}
        onHandleSubmit={this.handleSubmit}
        canSubmit={this.canSubmit}
        submitProject={this.submitProject}
        submitButtonEnabled={this.props.selectedRound === this.props.roundNumber}
        submitting={this.props.isSubmitting}
        onDeselectProject={this.handleDeselectProject}
        onDeselectBusiness={this.handleDeselectBusiness}
        selectedBusiness={this.state.selectedBusiness}
        onSelectBusiness={this.handleSelectBusiness}
        sidebarWidth={this.props.sidebarWidth}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  sidebarWidth: state.ui.sidebarWidth,
  selectedRound: state.game.selectedRound,
  teamNumber: state.team.id,
  roundNumber: state.game.currentRound,
  isLoading: state.projects.isLoading,
  isLoaded: state.projects.isLoaded,
  error: state.projects.error,
  projects: state.projects.projects,
  isSubmitting: state.projects.isSubmitting,
  isCurrentTab: state.ui.currentTab === 'SpecialProjects'
})

export default connect(mapStateToProps, { fetchProjects, submitProject, deleteProject })(SpecialProjectsContainer)
